<template lang="pug">
B3GisWrapper
</template>

<script>
import B3GisLoadIndicator from './B3GisLoadIndicator'

export default {
  name: 'B3GisView',

  components: {
    B3GisWrapper: () => ({
      component: import('@/components/B3Gis/B3GisWrapper'),
      loading: B3GisLoadIndicator
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/B3Gis/B3GisView.vue